import { z } from "zod";

/**
 * Create Slack Bot Path Variables
 */
export const CreateSlackBotPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type CreateSlackBotPathVars = z.infer<typeof CreateSlackBotPathVarsSchema>;

/**
 * Create Slack Bot Request Body
 */
export const CreateSlackBotBodySchema = z.object({
  workspaceConnectionId: z.string().uuid()
});

export type CreateSlackBotBody = z.infer<typeof CreateSlackBotBodySchema>;

/**
 * Create Slack Bot Response
 */
export const CreateSlackBotResponseSchema = z.object({
  appId: z.string(),
  botName: z.string(),
  apiKeyConnectionId: z.string().uuid(),
  webhookUrl: z.string()
});

export type CreateSlackBotResponse = z.infer<typeof CreateSlackBotResponseSchema>;
